import styled from 'styled-components';
import { theme } from '../../theme';

const { colors, up, breakpoints } = theme;

export const DivWrapper = styled.div`
  min-height: calc(100vh - 235px);
`;

export const DivStep = styled.div`
  visibility: hidden;
  height: 0;
  overflow: hidden;

  &.active {
    height: auto;
    visibility: visible;
  }
`;

export const DivColumn = styled.div`
  width: 100%;

  ${up(breakpoints.lg)} {
    width: 44%;

    &.full-width {
      width: 100%;
    }
  }
`;

export const DivTitle = styled.div`
  margin-bottom: 1.231rem;
  font-size: 1.154rem;
  font-weight: 600;
  color: ${colors.primary};
`;

export const DivInnerFields = styled.div`
  margin-left: 1.846rem;
  height: auto;

  &.hidden {
    visibility: hidden;
    height: 0;
  }

  & > div:not(:last-child) {
    margin-bottom: 1.231rem;
  }

  & .inner-fields-row {
    display: flex;
    flex-direction: column;
    margin-bottom: 0.769rem;

    & > div > div {
      margin-bottom: 1.231rem;
    }

    ${up(breakpoints.xl)} {
      flex-direction: row;

      & > div:first-of-type {
        margin-right: 150px;
      }
    }
    button.dropdown-toggle,
    .dropdown-menu {
      width: 11.923rem;
    }
  }
`;

export const DivFormWrapper = styled.div`
  max-height: calc(100vh - 350px);
  position: relative;

  ${up(breakpoints.sm)} {
    max-height: calc(100vh - 300px);
  }
`;
